import { useMemo } from 'react';
import { useWorkspace } from './useWorkspace';
import { getOrgPaidStatus } from '@trello/organizations';
import { useWorkspaceStatusQuery } from './WorkspaceStatusQuery.generated';

type WorkspaceStatus = ReturnType<typeof getOrgPaidStatus> | 'NO_TEAM';

export const useWorkspaceStatus = (): WorkspaceStatus | null => {
  const { idWorkspace } = useWorkspace();
  const { data, loading } = useWorkspaceStatusQuery({
    variables: { idOrganization: idWorkspace || '' },
    skip: !idWorkspace,
    waitOn: ['None'],
  });
  return useMemo(() => {
    if (loading) {
      return null;
    }
    return data?.organization ? getOrgPaidStatus(data.organization) : 'NO_TEAM';
  }, [loading, data?.organization]);
};
